import {
  createRootRouteWithContext,
  HeadContent,
  Outlet,
  Scripts,
} from '@tanstack/react-router';
import { Suspense } from 'react';

import {
  InternalServerErrorPage,
  NotFoundErrorPage,
} from '@mint-admin/secured-layout/routes';
import type { RouterContext } from '@mint-lib/admin-routing-context';

import {
  FlagsmithDevTools,
  TanStackRouterDevtools,
} from '../components/DevTools.js';

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Root,
  errorComponent: InternalServerErrorPage,
  notFoundComponent: NotFoundErrorPage,
  head: () => ({
    meta: [
      {
        title: 'MINT - Admin',
      },
    ],
  }),
});

function Root() {
  return (
    <>
      <HeadContent />
      <Outlet />
      <Suspense fallback={null}>
        <TanStackRouterDevtools />
        <FlagsmithDevTools />
      </Suspense>
      <Scripts />
    </>
  );
}
